const SET_ACCESS_TOKEN = 'AUTH/SET_ACCESS_TOKEN'
const SET_LAST_TOKEN = 'AUTH/SET_LAST_TOKEN'
const SET_TIME_OUT_NOTICE = 'AUTH/SET_TIME_OUT_NOTICE'
const SET_REDIRECT_AFTER_AUTH = 'AUTH/SET_REDIRECT_AFTER_AUTH'
const SET_FIREBASE_MESSAGING_TOKEN = 'AUTH/SET_FIREBASE_MESSAGING_TOKEN'
const SET_AUTH_REQUEST_DATA = 'AUTH/SET_AUTH_REQUEST_DATA'
const SET_LOGIN_STEP = 'AUTH/SET_LOGIN_STEP'
const SET_LOGIN_REQUESTID = 'AUTH/SET_LOGIN_REQUESTID'
const SET_RECOVERY_STEP = 'AUTH/SET_RECOVERY_STEP'
const SET_RECOVERY_REQUESTID = 'AUTH/SET_RECOVERY_REQUESTID'

export {
  SET_ACCESS_TOKEN,
  SET_LAST_TOKEN,
  SET_TIME_OUT_NOTICE,
  SET_REDIRECT_AFTER_AUTH,
  SET_FIREBASE_MESSAGING_TOKEN,
  SET_AUTH_REQUEST_DATA,
  SET_LOGIN_STEP,
  SET_LOGIN_REQUESTID,
  SET_RECOVERY_STEP,
  SET_RECOVERY_REQUESTID,
}
